import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = {
    key: 0,
    class: "q-pa-md text-h5 text-red text-weight-bold"
};
const _hoisted_4 = { class: "q-pa-md" };
const _hoisted_5 = { class: "dlg-content" };
const _hoisted_6 = { class: "dlg-actions" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_tab = _resolveComponent("q-tab");
    const _component_q_tabs = _resolveComponent("q-tabs");
    const _component_KaiyakuEntryCheckTable = _resolveComponent("KaiyakuEntryCheckTable");
    const _component_q_tab_panel = _resolveComponent("q-tab-panel");
    const _component_KaiyakuEntryHasonTable = _resolveComponent("KaiyakuEntryHasonTable");
    const _component_q_tab_panels = _resolveComponent("q-tab-panels");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_dialog = _resolveComponent("q-dialog");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    ...(_ctx.isMultipleKeiyaku
                        ? [{ itemId: _ctx.PageID.taikyoRoomList }]
                        : []),
                    { itemId: _ctx.PageID.taikyoFlowGuide },
                    { itemId: _ctx.PageID.kaiyakuGuide },
                    ...(_ctx.isShinsei
                        ? [
                            { itemId: _ctx.PageID.kaiyakuEntry },
                            ...(!_ctx.taikyoEntity.needTachiai && _ctx.myPageStore.selectedNyukyokeiyaku.roomSb === _ctx.RoomSb.Room
                                ? [{ itemId: _ctx.PageID.kaiyakuEntryHason }]
                                : []),
                        ]
                        : []),
                    { itemId: _ctx.PageID.kaiyakuEntryCheck }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                (_ctx.kaiyakuForInput.appliedInput && _ctx.isShinsei)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 入力に誤りがないか確認してください "))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_q_card, null, {
                                        default: _withCtx(() => [
                                            (_ctx.showHasonTab)
                                                ? (_openBlock(), _createBlock(_component_q_tabs, {
                                                    key: 0,
                                                    modelValue: _ctx.tab,
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.tab) = $event)),
                                                    class: "bg-grey-3 text-green-7 shadow-2",
                                                    "active-color": "white",
                                                    "active-bg-color": "green-7",
                                                    "indicator-color": "green-7",
                                                    "inline-label": "",
                                                    dense: "",
                                                    align: "justify",
                                                    breakpoint: 0
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_q_tab, {
                                                            name: "entry",
                                                            icon: "view_list",
                                                            label: "解約通知"
                                                        }),
                                                        _withDirectives(_createVNode(_component_q_tab, {
                                                            name: "hason",
                                                            icon: "dashboard",
                                                            label: "破損・汚損申告"
                                                        }, null, 512), [
                                                            [_vShow, !_ctx.taikyoEntity.needTachiai]
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["modelValue"]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_component_q_separator),
                                            _createVNode(_component_q_tab_panels, {
                                                modelValue: _ctx.tab,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.tab) = $event)),
                                                animated: ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_q_tab_panel, { name: "entry" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_KaiyakuEntryCheckTable, { kouzaForInput: _ctx.kouzaForInput }, null, 8, ["kouzaForInput"])
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_q_tab_panel, { name: "hason" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_KaiyakuEntryHasonTable, { readonly: "" })
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }, 8, ["modelValue"])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _createVNode(_component_q_dialog, {
                                    modelValue: _ctx.isKouzaChangeDialog,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.isKouzaChangeDialog) = $event)),
                                    class: "mypage-dialog dlg--no-title dlg--open",
                                    "transition-duration": "200",
                                    "transition-hide": "fade"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_q_card, { class: "dlg-wrapper" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.commonStore.messages.PI0028), 1),
                                                _createElementVNode("div", _hoisted_6, [
                                                    _createVNode(_component_q_btn, {
                                                        class: "dlg-action cancel-action",
                                                        flat: "",
                                                        label: "いいえ",
                                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.apply(false)))
                                                    }),
                                                    _createVNode(_component_q_btn, {
                                                        class: "dlg-action ok-action",
                                                        flat: "",
                                                        label: "はい",
                                                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.apply(true)))
                                                    })
                                                ])
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    label: "戻る",
                                    class: "btn-route col-5 col-md-3",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.router.back()))
                                }),
                                (_ctx.isShinsei)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        label: "申請",
                                        class: "btn-route col-5 col-md-3",
                                        color: "green-7",
                                        "icon-right": "navigate_next",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.onApplication()))
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
